import type { ReactNode } from "react";

/**
 * Reusable device frames used by the template preview and review screens so
 * the desktop/mobile presentation reads consistently everywhere.
 */

export function BrowserFrame({ url, children }: { url?: string; children: ReactNode }) {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
      <div className="flex items-center gap-2 px-4 py-2.5 bg-slate-50 border-b border-slate-200">
        <div className="flex gap-1.5">
          <span className="w-3 h-3 rounded-full bg-red-400" />
          <span className="w-3 h-3 rounded-full bg-amber-400" />
          <span className="w-3 h-3 rounded-full bg-emerald-400" />
        </div>
        <div className="flex-1 mx-4 flex items-center gap-2 bg-white border border-slate-200 rounded-md px-3 py-1 text-xs text-slate-400">
          <i className="ri-lock-line" />
          <span className="truncate">{url ?? "yourstore.example.com/product"}</span>
        </div>
      </div>
      <div className="bg-white">{children}</div>
    </div>
  );
}

export function PhoneFrame({ children }: { children: ReactNode }) {
  return (
    <div className="w-[375px] max-w-full overflow-hidden rounded-[2rem] border border-slate-300 bg-white">
      <div className="flex items-center justify-center gap-1.5 pt-3 pb-2 bg-white border-b border-slate-100">
        <div className="w-16 h-5 bg-slate-800 rounded-full" />
      </div>
      <div className="max-h-[760px] overflow-y-auto bg-white">{children}</div>
    </div>
  );
}